module.exports = __webpack_public_path__ + "img/phone.5ec7d0ae.svg";